// Copyright (c) 2024 by Audere

import { useGetStructuredDataQuery } from "../features/api/labelApiSlice";
import { selectCurrentUserPersistentGroupRole } from "../features/slices/authSlice";
import { useSelector } from "react-redux";

export const useStructuredData = (conversation_uid: string) => {
  const userGroupRole = useSelector(selectCurrentUserPersistentGroupRole);
  const { data, isFetching, error } = useGetStructuredDataQuery(
    {
      group: userGroupRole.group,
      conversation_uid: conversation_uid,
    },
    {
      pollingInterval: 0, // No polling
      skipPollingIfUnfocused: true,
      refetchOnFocus: false,
      refetchOnReconnect: true,
      skip: !conversation_uid,
    }
  );

  const structuredData = data?.structured_data ?? {};

  return { structuredData, isFetching, error };
};
